import { useState } from "react";
import { DatePicker } from "antd";
import api from "api/api";

//Props Validations
import PropTypes from "prop-types";

//Material UI Components
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import ListItemIcon from "@mui/material/ListItemIcon";

//Material UI Icons
import ClearIcon from "@mui/icons-material/Clear";
import { CircularProgress } from "@mui/material";

// import assets
import claimsMapping from "../../assets/icons/claimsMapping.png";
import excelIcon from "../../assets/excel-icon.png";

import { consumerFilterPayload } from "../../utils/consumerFilterUtils";

import { useSelector, useDispatch } from "react-redux";
import { showNotification } from "store/features/notificationSlice";

import { useLocation } from "react-router-dom";
import { generateBoxAnalysisPayloadBySelection, generateBoxAnalysisPayload } from "utils/boxAnalysisUtils";
const { RangePicker } = DatePicker;

// selectedClaimsTags = [1,2,3,4]
function DownloadDialog({ open = false, setOpen }) {
    const dispatch = useDispatch();
    const locationState = useLocation();
    const selectedCommonFiltersOnRespondent = useSelector((state) => state.respondentDashboardStore.currentFilter) || {};
    const consumerFilterStoreData = useSelector((state) => state.consumerFilterStore.currentSelectedFilters);
    const missingFilters = useSelector((state) => state.consumerFilterStore.missingFilters);
    const isFilterAcrossProducts = useSelector((state) => state.consumerFilterStore.isFilterAcrossProducts);
    const correlationConsumerFilterStoreData = useSelector((state) => state.correlationStore.currentSelectedFiltersForCorrelation);
    const correlationMissingFilters = useSelector((state) => state.correlationStore.missingFiltersForCorrelation);
    const isFilterAcrossProductsForCorrelation = useSelector((state) => state.correlationStore.isFilterAcrossProductsForCorrelation);
    const selectedCorrelationMethod = useSelector((state) => state.correlationStore.selectedCorrelationMethod);
    const selectedStudy = useSelector((state) => state.studyDataStore.selectedStudies);
    const productsOrder = useSelector((state) => state.productsInfoStore.productsOrder);
    const productsVisibility = useSelector((state) => state.productsInfoStore.productsVisibility);
    const selectedMicroCategory = useSelector((state) => state.analysisResultsStore.selectedMicroCategory);
    const selectedProductsforTest = useSelector((state) => state.tTestStore.tTestSelectedProducts);
    const userId = useSelector((state) => state.userStore.id);
    const textThemeSelections = useSelector((state) => state.textThemeStore.selections);
    const textThemeThemes = useSelector((state) => state.textThemeStore.themes);
    const textThemeSelectedOptions = useSelector((state) => state.textThemeStore.themeSelections);
    const textThemeAppliedConsumerFilters = useSelector((state) => state.textThemeStore.appliedConsumerFilters);
    const textThemeMissingConsumerFilters = useSelector((state) => state.textThemeStore.missingConsumerFilters);
    const textThemeFilterAcrossEnabled = useSelector((state) => state.textThemeStore.filterAcrossEnabled);

    const claimsAnalysisSelectedTagsFilter = useSelector((state) => state.claimsAnalysisStore.claimsAnalysisSelectedTagsFilter);
    const weightToggle = useSelector((state) => state.analysisResultsStore.weightToggle);
    const weightToggleForCorrelation = useSelector((state) => state.correlationStore.weightToggleForCorrelation);
    const overallToggle = useSelector((state) => state.analysisResultsStore.overallToggle);
    // const absoluteToggle = useSelector((state) => state.analysisResultsStore[`${moduleName}AbsoluteToggle`]);
    const overallAbsoluteToggle = useSelector((state) => state.analysisResultsStore[`overallAbsoluteToggle`]);
    const secondaryAbsoluteToggle = useSelector((state) => state.analysisResultsStore[`secondaryAbsoluteToggle`]);
    const agreementAbsoluteToggle = useSelector((state) => state.analysisResultsStore[`agreementAbsoluteToggle`]);
    const claimsAbsoluteToggle = useSelector((state) => state.analysisResultsStore[`claimsAbsoluteToggle`]);
    const top2BoxAggToggle = useSelector((state) => state.analysisResultsStore.top2BoxAggToggle);
    const top2BoxClaimsToggle = useSelector((state) => state.analysisResultsStore.top2BoxClaimsToggle);
    const isItmDataShown = useSelector((state) => state.analysisResultsStore.isItmDataShown);
    const selectedClaimsTags = useSelector((state) => state.claimsMappingStore.claimsMappingSelectedTagsFilter);
    const claimsTags = useSelector((state) => state.claimsMappingStore.tags);
    const overallRemovedKpiList = useSelector((state) => state.analysisKpiStore.overallRemovedKpiList).flatMap((item) => item.split(","));
    const secondaryRemovedKpiList = useSelector((state) => state.analysisKpiStore.secondaryRemovedKpiList).flatMap((item) => item.split(","));
    const agreementRemovedKpiList = useSelector((state) => state.analysisKpiStore.agreementRemovedKpiList).flatMap((item) => item.split(","));
    const claimsRemovedKpiList = useSelector((state) => state.analysisKpiStore.claimsRemovedKpiList).flatMap((item) => item.split(","));
    const correlationRemovedKpiList = useSelector((state) => state.analysisKpiStore.correlationRemovedKpiList.flatMap((item) => item.split(",")));
    const justRightRemovedKpiList = useSelector((state) => state.analysisKpiStore.justRightRemovedKpiList).flatMap((item) => item.split(","));
    const fragranceMetricsRemovedKpiList = useSelector((state) => state.analysisKpiStore.fragranceMetricsRemovedKpiList).flatMap((item) => item.split(","));
    // const productPreferenceRemovedKpiList = Object.keys(productsVisibility).map(key => key.replace(/^.*--/, '').replace(/__.*/, ''));
    const fragranceAssociationRemovedKpiList = useSelector((state) => state.analysisKpiStore.fragranceAssociationRemovedKpiList).flatMap((item) => item.split(","));
    const preferenceRemovedKpiList = useSelector((state) => state.analysisKpiStore.preferenceRemovedKpiList).flatMap((item) => item.split(","));
    const productCategoryData = useSelector((state) => state.settingsStore.productCategory);
    const significanceToggle = useSelector((state) => state.analysisResultsStore.significanceToggle);
    const percentageToggle = useSelector((state) => state.analysisResultsStore.percentageToggle);
    const isHairCare = process.env?.REACT_APP_HAIR_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isSkinCare = process.env?.REACT_APP_SKIN_CARE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const isUnileverFragranceHouse = process.env?.REACT_APP_UNILEVER_FRAGRANCE_HOUSE?.toLowerCase() === productCategoryData?.label?.toLowerCase();
    const penaltyToggle = useSelector((state) => state.analysisResultsStore.penaltyToggle);
    const isJar = isHairCare || isSkinCare || isUnileverFragranceHouse;
    const selectedProducts = useSelector((state) => state.respondentDashboardStore.productList);
    const targetKpi = useSelector((state) => state.driverAnalysisStore.targetKpi);
    const productCategoryId = productCategoryData?.value || null;
    const overallBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.overallBoxAnalysisSelection);
    const secondaryBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.secondaryBoxAnalysisSelection);
    const agreementBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.agreementBoxAnalysisSelection);
    const claimsBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.claimsBoxAnalysisSelection);
    const overallAnalysisTypeValue = useSelector((state) => state.analysisTypeSelectionStore.overallAnalysisTypeValue);
    const secondaryAnalysisTypeValue = useSelector((state) => state.analysisTypeSelectionStore.secondaryAnalysisTypeValue);
    const agreementAnalysisTypeValue = useSelector((state) => state.analysisTypeSelectionStore.agreementAnalysisTypeValue);
    const claimsAnalysisTypeValue = useSelector((state) => state.analysisTypeSelectionStore.claimsAnalysisTypeValue);
    const fragranceMetricsAnalysisTypeValue = useSelector((state) => state.analysisTypeSelectionStore.fragranceMetricsAnalysisTypeValue);
    const overallBoxAnalysisTypeSelection = useSelector((state) => state.analysisTypeSelectionStore.overallBoxAnalysisTypeSelection);
    const secondaryBoxAnalysisTypeSelection = useSelector((state) => state.analysisTypeSelectionStore.secondaryBoxAnalysisTypeSelection);
    const agreementBoxAnalysisTypeSelection = useSelector((state) => state.analysisTypeSelectionStore.agreementBoxAnalysisTypeSelection);
    const claimsBoxAnalysisTypeSelection = useSelector((state) => state.analysisTypeSelectionStore.claimsBoxAnalysisTypeSelection);
    const studyType = selectedStudy.length > 0 ? [...new Set(selectedStudy.map((ele) => ele.study_type))].join(", ") : null;
    const studyTypeMethod = selectedStudy.length > 0 ? [...new Set(selectedStudy.map((ele) => ele.study_type_method))].join(", ") : null;
    const centralizedDataMappingSelectedStudyType = useSelector((state) => state.dataControlStore.centralizedDataMappingSelectedStudyType);
    const centralizedDataMappingSelectedStudyTypeMethod = useSelector((state) => state.dataControlStore.centralizedDataMappingSelectedStudyTypeMethod);
    const respondentSettingsStudyType = useSelector((state) => state.settingsStore.respondentSettingsStudyType);
    const respondentSettingsStudyTypeMethod = useSelector((state) => state.settingsStore.respondentSettingsStudyTypeMethod);
    // Express CLT - Overall
    const expressCltOverallTypeValue = useSelector((state) => state.analysisTypeSelectionStore.expressCltOverallTypeValue);
    const expressCltOverallBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.expressCltOverallBoxAnalysisSelection);
    const expressCltOverallBoxAnalysisTypeSelection = useSelector((state) => state.analysisTypeSelectionStore.expressCltOverallBoxAnalysisTypeSelection);
    // Express CLT - Additional
    const expressCltAdditionalTypeValue = useSelector((state) => state.analysisTypeSelectionStore.expressCltAdditionalTypeValue);
    const expressCltAdditionalBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.expressCltAdditionalBoxAnalysisSelection);
    const expressCltAdditionalBoxAnalysisTypeSelection = useSelector((state) => state.analysisTypeSelectionStore.expressCltAdditionalBoxAnalysisTypeSelection);
    // CLT - Overall
    const fragranceOverallTypeValue = useSelector((state) => state.analysisTypeSelectionStore.fragranceOverallTypeValue);
    const fragranceOverallBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.fragranceOverallBoxAnalysisSelection);
    const fragranceOverallBoxAnalysisTypeSelection = useSelector((state) => state.analysisTypeSelectionStore.fragranceOverallBoxAnalysisTypeSelection);
    //  CLT - Additional
    const fragranceAdditionalTypeValue = useSelector((state) => state.analysisTypeSelectionStore.fragranceAdditionalTypeValue);
    const fragranceAdditionalBoxAnalysisSelection = useSelector((state) => state.analysisTypeSelectionStore.fragranceAdditionalBoxAnalysisSelection);
    const fragranceAdditionalBoxAnalysisTypeSelection = useSelector((state) => state.analysisTypeSelectionStore.fragranceAdditionalBoxAnalysisTypeSelection);
    // Fragrance Association
    const overallFragranceToggle = useSelector((state) => state.analysisResultsStore.overallFragranceToggle || false);
    const openParentList = useSelector((state) => state.analysisResultsStore.fragranceAssociationOpenParentList);
    const tTestSelections = useSelector((state) => state.tTestStore.tTestSelections);
    const tTestFaLegends = useSelector((state) => state.tTestStore.tTestFaLegends);

    // t test
    const tTestPerformed = useSelector((state) => state.tTestStore.tTestPerformed);
    const tTestconfidenceInterval = useSelector((state) => state.tTestStore.tTestconfidenceInterval);
    const tTestType = useSelector((state) => state.tTestStore.tTestType);
    const tTestProducts = useSelector((state) => state.tTestStore.tTestProducts);
    const tTestCoreDataId = useSelector((state) => state.tTestStore.tTestCoreDataId);
    const tTestCheckedDataTypeForTest = useSelector((state) => state.tTestStore.tTestCheckedDataTypeForTest);
    const tTestAnalysisType = useSelector((state) => state.tTestStore.tTestAnalysisType);
    const tTestBoxAnalysis = useSelector((state) => state.tTestStore.tTestBoxAnalysis);

    const cohensDPerformed = useSelector((state) => state.cohensDStore.cohensDPerformed);
    const cohensdCoreDataId = useSelector((state) => state.cohensDStore.cohensdCoreDataId);
    const cohensdBackendVariables = useSelector((state) => state.cohensDStore.cohensdBackendVariables);
    const cohensdProductCodes = useSelector((state) => state.cohensDStore.cohensdProductCodes);

    // match net
    const selectedAlgorithm = useSelector((state) => state.matchNetStore.selectedStudyType);
    const lookupProducts = useSelector((state) => state.matchNetStore.lookupProducts);
    const lookupSelectedProducts = useSelector((state) => state.matchNetStore.lookupSelectedProducts);
    const matchNetConsumerFilters = useSelector((state) => state.matchNetStore.consumerFilters);
    const matchNetWeightToggle = useSelector((state) => state.matchNetStore.weightToggle);
    const allDataMappingFilters = useSelector((state) => state.matchNetStore.allDataMappingFilters);
    const matchNetProductSecondaryData = useSelector((state) => state.matchNetStore.productSecondaryData);

    const matchNetCorrelationToggle = useSelector((state) => state.matchNetStore.correlationToggle);
    const matchNetCorrelationMethod = useSelector((state) => state.matchNetStore.correlationMethod);
    const matchNetCorrelationTargetVariable = useSelector((state) => state.matchNetStore.correlationTargetVariable);
    const matchNetCorrelationStudyTypeMethod = useSelector((state) => state.matchNetStore.correlationStudyTypeMethod);
    const matchNetCheckedVariablesList = useSelector((state) => state.matchNetStore.checkedVariables);
    const interpolationToggle = useSelector((state) => state.matchNetStore.interpolationToggle);
    const interpolationDetails = useSelector((state) => state.matchNetStore.interpolationDetails);

    // active tab
    const activeTab = useSelector((state) => state.analysisResultsStore.activeTab);

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [isDownloading, setIsDownloading] = useState(false);

    const [userAccessDates, setUserAccessDates] = useState({ start: null, end: null });
    const [usageTrackingDates, setUsageTrackingDates] = useState({ start: null, end: null });

    const excluded_backend_variables = Object.keys(productsVisibility).reduce(
        (acc, key) => {
            const [, backendVariable, coreDataId] =
                key.match(/--(.*?)__(\d+)$/) || [];

            if (!backendVariable || !coreDataId) return acc;

            const id = Number(coreDataId);

            let entry = acc.find(
                item => item.core_data_model_id === id
            );

            if (!entry) {
                entry = {
                    core_data_model_id: id,
                    backend_variables: []
                };
                acc.push(entry);
            }

            entry.backend_variables.push(backendVariable);

            return acc;
        },
        []
    );
    const formatMissingFilters = (missingFiltersObj = {}) => {
        return Object.entries(missingFiltersObj || {}).reduce((acc, [key, value]) => {
            if (Array.isArray(value)) {
                acc[key] = value.map((v) => v?.value).filter(Boolean).join(", ");
            } else {
                acc[key] = value;
            }
            return acc;
        }, {});
    };

    const variableCategory = {
        overallKpiAnalysis: "KPI (OO)",
        correlation: "KPI (OO),Secondary Attribute,Agreement KPI",
        driverAnalysis: null,
        secondaryAttributeAnalysis: "Secondary Attribute",
        agreementKpiAnalysis: "Agreement KPI",
        respondentProfile: "",
        claimsAnalysis: "Claim",
        justRightAnalysis: isJar ? "JAR" : "Just Right",
        preferenceAnalysis: "Preference Analysis",
        productPreferenceAnalysis: "Product Preference Analysis",
        fragranceMetricsAnalysis: "Fragrance Metrics Analysis",
        fragranceAssociationAnalysis: "Fragrance Association",
        textThemeAnalysis: "Open Ended",
        matchNetLookup: null,
        matchNetCrossStudyComparison: null,
    };
    const handleStartDateChange = (date, dateString) => {
        if (dateString[0]) {
            // start date
            setStartDate(dateString[0]);
        } else {
            setStartDate(null);
        }
        if (dateString[1]) {
            // end date
            setEndDate(dateString[1]);
        } else {
            setEndDate(null);
        }
    };

    const handleUserAccessDateChange = (date, dateString) => {
        setUserAccessDates({
            start: dateString[0] || null,
            end: dateString[1] || null,
        });
    };

    const handleUsageTrackingDateChange = (date, dateString) => {
        setUsageTrackingDates({
            start: dateString[0] || null,
            end: dateString[1] || null,
        });
    };

    const urls = {
        overallKpi: process.env.REACT_APP_SERVER_PATH + `/secondary-study-datas/analysis-report/`,
        secondaryAttribute: process.env.REACT_APP_SERVER_PATH + `/secondary-study-datas/analysis-report/`,
        correlation: process.env.REACT_APP_SERVER_PATH + `/secondary-study-datas/correlation-export/`,
        respondentProfile: process.env.REACT_APP_SERVER_PATH + `/study-datas/respondent-profile-dashboard-report/`,
        agreementComparison: process.env.REACT_APP_SERVER_PATH + `/secondary-study-datas/analysis-report/`,
        userManagement: {
            access: process.env.REACT_APP_SERVER_PATH + `/profiles/report/`,
            usage: process.env.REACT_APP_SERVER_PATH + `/driver-analysis-output/history-export/`,
        },
        claimsAnalysis: process.env.REACT_APP_SERVER_PATH + `/secondary-study-datas/analysis-report/`,
        respondentSettings:
            startDate && endDate
                ? process.env.REACT_APP_SERVER_PATH + `/respondent-settings/history/?product_category=${productCategoryId}&start_date=${startDate}&end_date=${endDate}&study_type=${respondentSettingsStudyType?.value}&study_type_method=${respondentSettingsStudyTypeMethod?.map(ele => ele.value)?.join(",")}`
                : process.env.REACT_APP_SERVER_PATH + `/respondent-settings/history/?product_category=${productCategoryId}&study_type=${respondentSettingsStudyType?.value}&study_type_method=${respondentSettingsStudyTypeMethod?.value}`,
        justRightAnalysis: process.env.REACT_APP_SERVER_PATH + `/secondary-study-datas/analysis-report/`,
        centralizedDataMapping: process.env.REACT_APP_SERVER_PATH + `/data-mappings/history-report/?product_category=${productCategoryId}&study_type=${centralizedDataMappingSelectedStudyType?.value}&study_type_method=${centralizedDataMappingSelectedStudyTypeMethod?.map(ele => ele.value)?.join(",")}`,
        preferenceAnalysis: process.env.REACT_APP_SERVER_PATH + `/secondary-study-datas/analysis-report/`,
        productPreferenceAnalysis: process.env.REACT_APP_SERVER_PATH + `/secondary-study-datas/analysis-report/`,
        fragranceMetricsAnalysis: process.env.REACT_APP_SERVER_PATH + `/secondary-study-datas/analysis-report/`,
        fragranceAssociationAnalysis: process.env.REACT_APP_SERVER_PATH + `/secondary-study-datas/analysis-report/`,
        textThemeAnalysis: process.env.REACT_APP_SERVER_PATH + `/secondary-study-datas/analysis-report/`,
        matchNetLookup: process.env.REACT_APP_SERVER_PATH + `/deodrants-match-net-analysis/lookup-report/`,
        matchNetCrossStudyComparison: process.env.REACT_APP_SERVER_PATH + `/deodrants-match-net-analysis/analysis-report/`,
    };

    let page = null;
    // for payload
    let downloadComponentName = null;
    let downloadPageName = null;
    let absoluteToggle = false;

    if (window.location.href.includes("data-control-panel")) {
        if (window.location.href.includes("claims-mapping")) {
            page = "claimsMapping";
            downloadComponentName = "claimsMapping";
            downloadPageName = "claimsMapping";
        } else if (window.location.href.includes("centralized-data-mapping")) {
            page = "centralizedDataMapping";
        } else if (window.location.href.includes("study-method-management")) {
            page = "studyMethodManagement";
        } else if (window.location.href.includes("data-management")) {
            page = "dataManagement";
        } else if (window.location.href.includes("respondent-settings")) {
            page = "respondentSettings";
        } else {
            page = "dataControlPanel";
        }
    } else if (window.location.href.split("/").indexOf("overall-kpi") !== -1) {
        page = "overallKpi";
        // for payload
        downloadComponentName = "overallKpiDataState";
        downloadPageName = "overallKpiAnalysis";
        absoluteToggle = overallAbsoluteToggle;
    } else if (window.location.href.split("/").indexOf("secondary-attribute") !== -1) {
        page = "secondaryAttribute";
        // for payload
        downloadComponentName = "overallKpiDataState";
        downloadPageName = "secondaryAttributeAnalysis";
        absoluteToggle = secondaryAbsoluteToggle;
    } else if (window.location.href.split("/").indexOf("correlation") !== -1) {
        page = "correlation";
        downloadPageName = "correlation";
        downloadComponentName = "correlationDataState";
    } else if (window.location.href.split("/").indexOf("agreement-analysis") !== -1) {
        page = "agreementComparison";
        // for payload
        downloadComponentName = "agreementKpiDataState";
        downloadPageName = "agreementKpiAnalysis";
        absoluteToggle = agreementAbsoluteToggle;
    } else if (window.location.href.split("/").indexOf("user-management") !== -1) {
        page = "userManagement";
    } //else if (window.location.href.split("/").indexOf("respondent-module") !== -1) {
    else if (window.location.href.includes("respondent-module")) {
        page = "respondentProfile";
        if (window.location.href.includes("component") && window.location.href.includes("page")) {
            let urlParams = new URLSearchParams(window.location.search);
            downloadComponentName = urlParams.get("component");
            downloadPageName = urlParams.get("page");
        } else {
            downloadComponentName = "respondentProfile";
            downloadPageName = "respondentProfile";
        }
    } else if (window.location.href.includes("respondent-settings")) {
        page = "respondentSettings";
    } else if (window.location.href.split("/").indexOf("driver-analysis") !== -1) {
        page = "driverAnalysis";
    } else if (window.location.href.split("/").indexOf("claims-mapping") !== -1) {
        page = "claimsMapping";
    } else if (window.location.href.split("/").indexOf("claims-analysis") !== -1) {
        page = "claimsAnalysis";
        // for payload
        downloadComponentName = "claimsAnalysisDataState";
        downloadPageName = "claimsAnalysis";
        absoluteToggle = claimsAbsoluteToggle
    } else if (window.location.href.split("/").indexOf("just-right-analysis") !== -1) {
        page = "justRightAnalysis";
        downloadComponentName = "justRightDataState";
        downloadPageName = "justRightAnalysis";
    } else if (window.location.href.includes("product-preference-analysis")) {
        page = "productPreferenceAnalysis";
        downloadComponentName = "fragranceMetricsDataState";
        downloadPageName = "productPreferenceAnalysis";
    } else if (window.location.href.includes("preference-analysis")) {
        page = "preferenceAnalysis";
        downloadComponentName = "fragranceMetricsDataState";
        downloadPageName = "preferenceAnalysis";
    } else if (window.location.href.split("/").indexOf("fragrance-metrics-analysis") !== -1) {
        page = "fragranceMetricsAnalysis";
        downloadComponentName = "fragranceMetricsDataState";
        downloadPageName = "fragranceMetricsAnalysis";
    } else if (window.location.href.split("/").indexOf("fragrance-association") !== -1) {
        page = "fragranceAssociationAnalysis";
        downloadComponentName = "fragranceAssociationsDataState";
        downloadPageName = "fragranceAssociationAnalysis";
    } else if (window.location.href.includes("text-theme-analysis")) { // Added for Text Theme Export
        page = "textThemeAnalysis";
        downloadComponentName = "textThemeDataState";
        downloadPageName = "textThemeAnalysis";
    } else if (window.location.href.includes("lookup")) { // Added for Text Theme Export
        page = "matchNetLookup";
        downloadComponentName = "matchNetDataState";
        downloadPageName = "matchNetLookup";
    } else if (window.location.href.includes("cross-study-comparison")) { // Added for Text Theme Export
        page = "matchNetCrossStudyComparison";
        downloadComponentName = "matchNetCrossStudyComparisonDataState";
        downloadPageName = "matchNetCrossStudyComparison";
    } else {
        page = null;
    }

    const handleDownloadDialogClose = () => {
        setOpen(false);
    };

    const getQueryParam = (param) => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        return urlParams.get(param);
    };

    const getBoxAnalysisPayload = (analysisTypeValue, boxAnalysisSelection, boxAnalysisTypeSelection) => {
        if (analysisTypeValue == "mean") {
            return {};
        } else if (boxAnalysisTypeSelection.length === 2) {
            return generateBoxAnalysisPayload(boxAnalysisSelection);
        } else {
            return generateBoxAnalysisPayloadBySelection(boxAnalysisSelection, boxAnalysisTypeSelection[0]?.toLowerCase().split(" ")[0]) ?? {};
        }
    };

    const AnalysisResultExcelExportPayload = (componentName, pageName) => {
        const finalProducts = productsOrder.filter((datum) => {
            const formattedKey = `checked--${datum.productCode.split(" ").join("_")}__${datum.coreDataId}`;
            return productsVisibility[formattedKey] !== true; // Check both existence and value
        });

        let data = {
            server_side: true,
            variable_category: "",
            core_data_model_id: "",
            weight_toggle: pageName !== "correlation" ? weightToggle : weightToggleForCorrelation,
            filter_across_products_toggle: pageName === "correlation"
                ? isFilterAcrossProductsForCorrelation
                : pageName === "textThemeAnalysis"
                    ? textThemeFilterAcrossEnabled
                    : isFilterAcrossProducts,
            test_details: {},
            // excluded_backend_variables: overallRemovedKpiList,
            product_sequence: finalProducts, //done
            // data_view: dataView?.value || null,
            // agreement and claims,
            study_type: studyType,
            study_type_method: studyTypeMethod,
        };

        if (pageName === "justRightAnalysis") {
            data["data_view"] = "middle_box";
        }

        if (pageName === "overallKpiAnalysis") {
            data["overall_toggle"] = overallToggle;
            data["excluded_backend_variables"] = overallRemovedKpiList;
            data["itm_toggle"] = isItmDataShown;
            data["box_analysis"] = getBoxAnalysisPayload(overallAnalysisTypeValue.value, overallBoxAnalysisSelection, overallBoxAnalysisTypeSelection);
            data["data_view"] = overallAnalysisTypeValue.value || null;
            data["absolute_count_toggle"] = absoluteToggle;
        } else if (pageName === "secondaryAttributeAnalysis") {
            data["overall_toggle"] = overallToggle;
            data["excluded_backend_variables"] = secondaryRemovedKpiList;
            data["box_analysis"] = getBoxAnalysisPayload(secondaryAnalysisTypeValue.value, secondaryBoxAnalysisSelection, secondaryBoxAnalysisTypeSelection);
            data["data_view"] = secondaryAnalysisTypeValue.value || null;
            data["absolute_count_toggle"] = absoluteToggle;
        } else if (pageName === "agreementKpiAnalysis") {
            data["overall_toggle"] = overallToggle;
            data["excluded_backend_variables"] = agreementRemovedKpiList;
            data["top_2_box"] = top2BoxAggToggle?.value === "top_2_box";
            data["significance_toggle"] = significanceToggle;
            data["box_analysis"] = getBoxAnalysisPayload(agreementAnalysisTypeValue.value, agreementBoxAnalysisSelection, agreementBoxAnalysisTypeSelection);
            data["data_view"] = agreementAnalysisTypeValue.value || null;
            data["absolute_count_toggle"] = absoluteToggle;
        } else if (pageName === "claimsAnalysis") {
            data["excluded_backend_variables"] = claimsRemovedKpiList;
            data["top_2_box"] = top2BoxClaimsToggle.value === "top_2_box";
            data["absolute_count_toggle"] = absoluteToggle;
            if (claimsAnalysisSelectedTagsFilter.length) {
                const ids = claimsTags.filter((datum) => claimsAnalysisSelectedTagsFilter.indexOf(datum.title) !== -1).map((ele) => ele.id);
                data["claims_tag_filter"] = ids;
            }
            data["box_analysis"] = getBoxAnalysisPayload(claimsAnalysisTypeValue.value, claimsBoxAnalysisSelection, claimsBoxAnalysisTypeSelection);
            data["data_view"] = claimsAnalysisTypeValue.value || null;
        } else if (pageName === "justRightAnalysis") {
            data["overall_toggle"] = overallToggle;
            data["excluded_backend_variables"] = justRightRemovedKpiList;
            if (penaltyToggle) data["penalty_analysis_toggle"] = penaltyToggle;
        } else if (pageName === "correlation") {
            data["target_variable"] = targetKpi;
            data["excluded_backend_variables"] = correlationRemovedKpiList;
            data["correlation_method"] = selectedCorrelationMethod.value;
        } else if (pageName === "preferenceAnalysis") {
            data["percentage_toggle"] = percentageToggle;
            data["significance_toggle"] = significanceToggle;
            data["excluded_backend_variables"] = preferenceRemovedKpiList;
        } else if (pageName === "productPreferenceAnalysis") {
            data["percentage_toggle"] = percentageToggle;
            data["excluded_backend_variables"] = excluded_backend_variables;
            data["macro_category_tab"] = selectedMicroCategory ? selectedMicroCategory : null;
            data["product_sequence"] = finalProducts.sort((a, b) => a.coreDataId - b.coreDataId);
        } else if (pageName === "fragranceMetricsAnalysis") {
            const pathname = window.location.pathname;
            let analysisTypeValue = fragranceMetricsAnalysisTypeValue.value;
            let boxSelection = {};
            let boxTypeSelection = [];
            data["excluded_backend_variables"] = fragranceMetricsRemovedKpiList;
            if (pathname.includes("/express-clt/")) {
                if (pathname.endsWith("/overall-analysis")) {
                    analysisTypeValue = expressCltOverallTypeValue.value;
                    boxSelection = expressCltOverallBoxAnalysisSelection;
                    boxTypeSelection = expressCltOverallBoxAnalysisTypeSelection;
                    data["excluded_backend_variables"] = overallRemovedKpiList;
                } else if (pathname.endsWith("/additional-analysis")) {
                    analysisTypeValue = expressCltAdditionalTypeValue.value;
                    boxSelection = expressCltAdditionalBoxAnalysisSelection;
                    boxTypeSelection = expressCltAdditionalBoxAnalysisTypeSelection;
                    data["excluded_backend_variables"] = secondaryRemovedKpiList;
                }
            } else if (pathname.includes("/clt/")) {
                if (pathname.endsWith("/overall-analysis")) {
                    analysisTypeValue = fragranceOverallTypeValue.value;
                    boxSelection = fragranceOverallBoxAnalysisSelection;
                    boxTypeSelection = fragranceOverallBoxAnalysisTypeSelection;
                    data["excluded_backend_variables"] = overallRemovedKpiList;
                } else if (pathname.endsWith("/additional-analysis")) {
                    analysisTypeValue = fragranceAdditionalTypeValue.value;
                    boxSelection = fragranceAdditionalBoxAnalysisSelection;
                    boxTypeSelection = fragranceAdditionalBoxAnalysisTypeSelection;
                    data["excluded_backend_variables"] = secondaryRemovedKpiList;
                }
            }
            data["data_view"] = analysisTypeValue || null;
            data["box_analysis"] = getBoxAnalysisPayload(analysisTypeValue, boxSelection, boxTypeSelection);

            data["significance_toggle"] = significanceToggle;

            if (cohensDPerformed) {
                data["cohensd_details"] = {
                    core_data_id: cohensdCoreDataId,
                    backend_variables: cohensdBackendVariables,
                    product_codes: cohensdProductCodes,
                };
            }

            if (pathname.includes("/express-clt/")) {
                if (pathname.endsWith("/overall-analysis")) {
                    data["module_name_type"] = "Overall Analysis";
                } else if (pathname.endsWith("/additional-analysis")) {
                    data["module_name_type"] = "Additional Analysis";
                }
            } else if (pathname.includes("/clt/")) {
                if (pathname.endsWith("/overall-analysis")) {
                    data["module_name_type"] = "Overall Analysis";
                } else if (pathname.endsWith("/additional-analysis")) {
                    data["module_name_type"] = "Additional Analysis";
                }
            }
        } else if (pageName === "fragranceAssociationAnalysis") {
            data["percentage_toggle"] = percentageToggle;
            data["excluded_backend_variables"] = fragranceAssociationRemovedKpiList;
            data["overall_fragrance_toggle"] = overallFragranceToggle;
            data["is_parent_child"] = true;
            data["significance_toggle"] = significanceToggle;
            data["parent_child_open_state"] = openParentList;
            data["overall_note"] = overallFragranceToggle && significanceToggle;
            data["fragrance_note"] = significanceToggle && tTestFaLegends[0]?.title ? true : false;
            data["fragrance_association_tab"] = activeTab;
            if (tTestPerformed) {
                let _products_fragrance_association = [];

                tTestSelections["fragranceAssociation"]["products"].forEach((datum) => {
                    _products_fragrance_association.push(datum.title);
                });
                data.fragrance_test_details = {
                    core_data_model_id: tTestCoreDataId.toString(),
                    products: _products_fragrance_association,
                    test_name: tTestSelections?.fragranceAssociation?.test_name,
                    confidence_interval: tTestSelections?.fragranceAssociation?.confidence_interval * 100,
                    weight_toggle: weightToggle,
                    product_category: productCategoryId,
                    box_analysis: {},
                    within_product: tTestSelections?.fragranceAssociation?.within_product,
                };

                if (overallFragranceToggle) {
                    let _products = [];

                    tTestSelections["overall"]["products"].forEach((datum) => {
                        _products.push(datum.title);
                    });
                    data.test_details = {
                        core_data_model_id: tTestCoreDataId.toString(),
                        study_type: studyType,
                        study_type_method: studyTypeMethod,
                        variable_category: variableCategory[pageName],
                        products: _products,
                        test_name: tTestSelections?.overall?.test_name,
                        confidence_interval: tTestSelections?.overall?.confidence_interval * 100,
                        weight_toggle: weightToggle,
                        product_category: productCategoryId,
                        box_analysis: {},
                    };
                } else {
                    data.test_details = {};
                }
            }
        } else if (pageName === "textThemeAnalysis") {
            data["module_name_type"] = locationState.state?.from;

            const activeSelections = textThemeSelections.filter((item) => item.isSelected === true);
            const flattenedThemeSelections = Object.values(textThemeSelectedOptions || {}).flat();

            if (activeSelections.length > 0) {
                const selectedBackendVariables = [
                    ...new Set(flattenedThemeSelections.map((selection) => selection.backend_variable).filter(Boolean)),
                ];
                data["backend_variable"] = selectedBackendVariables.length > 0
                    ? selectedBackendVariables.join(",")
                    : activeSelections[0].backendVariable;

                const productSequenceForTextTheme = activeSelections.map((selection) => {
                    const coreDataId = selection.coreDataId;
                    const productCodeRaw = selection.productCodeTitle;
                    const productCode = productCodeRaw.replace(/_/g, " ");

                    const study = selectedStudy.find((s) => String(s.id) === String(coreDataId));
                    const isCompetitor = study?.competitor_products?.includes(productCode) ?? false;

                    return {
                        productCode: productCode,
                        coreDataId: parseInt(coreDataId, 10),
                        isCompetitor: isCompetitor,
                    };
                });
                
                data["product_sequence"] = productSequenceForTextTheme;
            }

            data["themes"] = textThemeThemes;
            data["theme_selections"] = flattenedThemeSelections;
            data["itm_toggle"] = isItmDataShown;
            data["applied_consumer_filters"] = textThemeAppliedConsumerFilters || [];
            data["missing_consumer_filters"] = textThemeMissingConsumerFilters || [];
        }


        if (isItmDataShown && pageName === "overallKpiAnalysis") {
            data["variable_category"] = variableCategory[pageName] + `,KPI ITM`;
        } else if (pageName === "fragranceMetricsAnalysis" && window.location.href.split("/").indexOf("clt") !== -1) {
            data["variable_category"] = variableCategory[pageName] + `,JAR`;
        } else {
            data["variable_category"] = variableCategory[pageName];
        }

        // coreDataIds
        const coreDataIds = selectedStudy.map((ele) => ele.id)?.join(",");
        data["core_data_model_id"] = coreDataIds;

        // test_details
        if (tTestPerformed && pageName !== "fragranceAssociationAnalysis") {
            data.test_details = {
                core_data_model_id: tTestCoreDataId.toString(),
                test_name: tTestType,
                confidence_interval: tTestconfidenceInterval * 100,
                data_view: tTestAnalysisType,
            };
            if (pageName === "productPreferenceAnalysis") {
                const uniqueProducts = [
                    ...new Set(
                        selectedProductsforTest.flatMap(item => item.products)
                    )
                ];

                const comparisons = Object.fromEntries(
                    selectedProductsforTest.map(item => [
                        item.backendVariable,
                        item.products
                    ])
                );

                data.test_details = {
                    ...data.test_details,
                    products: uniqueProducts,
                    comparisons: comparisons
                }
            } else {
                data.test_details = {
                    ...data.test_details,
                    products: tTestProducts.split(","),
                };
            }

            if (tTestBoxAnalysis && Object.keys(tTestBoxAnalysis).length > 0) {
                data.test_details.box_analysis = tTestBoxAnalysis;
            }

            if (isItmDataShown && pageName === "overallKpiAnalysis" && tTestCheckedDataTypeForTest) {
                data.test_details.data_type = tTestCheckedDataTypeForTest;
            }
        }

        if (!data.applied_consumer_filters) {
            let _consumer_filters = [];
            let productCodes = [];
            let selectedProduct = getQueryParam("product_code");
            let selectedCodeDataId = getQueryParam("core_data_id");

            if (selectedProduct && selectedCodeDataId) {
                const product = selectedProduct.split(" ").join("_");
                let _tempFilters = pageName !== "correlation" ? consumerFilterPayload(consumerFilterStoreData, product, selectedCodeDataId) : consumerFilterPayload(correlationConsumerFilterStoreData, product, selectedCodeDataId);

                data = {
                    ...data,
                    ..._tempFilters,
                    product_code: selectedProduct,
                };
            } else {
                selectedStudy.forEach((study) => {
                    study.products?.forEach((product) => {
                        let datum = {};
                        datum.title = product;
                        datum.coreDataId = study.id;
                        productCodes.push(datum);
                    });
                    study.competitor_products?.forEach((product) => {
                        let datum = {};
                        datum.title = product;
                        datum.coreDataId = study.id;
                        productCodes.push(datum);
                    });
                });
                productCodes.forEach((datum) => {
                    const product = datum.title.split(" ").filter(item => item != "").join("_");
                    let productCf = {
                        product_code: datum.title,
                        core_data_model_id: datum.coreDataId.toString(),
                    };
                    let _tempFilters = pageName !== "correlation" ? consumerFilterPayload(consumerFilterStoreData, product, datum.coreDataId) : consumerFilterPayload(correlationConsumerFilterStoreData, product, datum.coreDataId);
                    if (_tempFilters && Object.keys(_tempFilters).length > 0) {
                        productCf = {
                            ...productCf,
                            ..._tempFilters,
                        };
                        _consumer_filters.push(JSON.parse(JSON.stringify(productCf)));
                    }
                });
                data["applied_consumer_filters"] = _consumer_filters;
            }
        }
        if (!data.missing_consumer_filters) {
            let _consumer_filters = [];
            let productCodes = [];
            let selectedProduct = getQueryParam("product_code");
            let selectedCodeDataId = getQueryParam("core_data_id");

            if (selectedProduct && selectedCodeDataId) {
                const product = selectedProduct.split(" ").join("_");
                let _tempFilters = pageName !== "correlation" ? consumerFilterPayload(missingFilters, product, selectedCodeDataId) : consumerFilterPayload(correlationMissingFilters, product, selectedCodeDataId);

                data = {
                    ...data,
                    ..._tempFilters,
                    product_code: selectedProduct,
                };
            } else {
                selectedStudy.forEach((study) => {
                    study.products?.forEach((product) => {
                        let datum = {};
                        datum.title = product;
                        datum.coreDataId = study.id;
                        productCodes.push(datum);
                    });
                    study.competitor_products?.forEach((product) => {
                        let datum = {};
                        datum.title = product;
                        datum.coreDataId = study.id;
                        productCodes.push(datum);
                    });
                });
                productCodes.forEach((datum) => {
                    const product = datum.title.split(" ").filter(item => item != "").join("_");
                    let productCf = {
                        product_code: datum.title,
                        core_data_model_id: datum.coreDataId.toString(),
                    };
                    let _tempFilters = pageName !== "correlation" ? consumerFilterPayload(missingFilters, product, datum.coreDataId) : consumerFilterPayload(correlationMissingFilters, product, datum.coreDataId);
                    if (_tempFilters && Object.keys(_tempFilters).length > 0) {
                        productCf = {
                            ...productCf,
                            ..._tempFilters,
                        };
                        _consumer_filters.push(JSON.parse(JSON.stringify(productCf)));
                    }
                });
                data["missing_consumer_filters"] = _consumer_filters;
            }
        }

        data["product_category"] = parseInt(productCategoryId);

        return data;
    };
    
    const parseProductString = (option = "") => {
        let productTitle;
        let cd;

        const spilitArr = option.split("*/*");
        if (spilitArr.length > 1) {
            cd = spilitArr[spilitArr.length - 1];
            productTitle = spilitArr[0];
        }

        return {
            pc: productTitle,
            cd: cd,
        };
    };

    const joinArraysInObject = (obj) => {
        const result = {};

        for (const key in obj) {
            if (Array.isArray(obj[key])) {
                if (key === "product_codes") {
                    result["product_code"] = obj[key].map((product) => {
                        const { pc, cd } = parseProductString(product);
                        return {
                            pc: pc,
                            core_data_model_id: cd,
                        };
                    });
                } else {
                    result[key] = obj[key].map((item) => item.replace(/,/g, " |")).join(",");
                }
            }
        }

        return result;
    };

    function RespondentExcelExportPayload() {
        const coreDataIds = selectedStudy.map((ele) => ele.id)?.join(",");
        let payload = {
            product_sequences: [],
            core_data_ids: coreDataIds.toString(),
            return_respondent: true,
            filters: joinArraysInObject(selectedCommonFiltersOnRespondent),
        };
        if (selectedProducts.length !== 0) {
            const productDetails = selectedProducts?.map((datum) => {
                let data = {
                    pc: datum.productName.split("_").join(" "),
                    core_data_model_id: datum.coreDataId.toString(),
                    is_competitor: datum.isCompetitor,
                };
                let _tempFilters = consumerFilterPayload(consumerFilterStoreData, datum.productName, datum.coreDataId);
                if (_tempFilters && Object.keys(_tempFilters).length > 0) {
                    data = {
                        ...data,
                        ..._tempFilters,
                    };
                }

                return data;
            });
            payload["product_sequences"] = [...productDetails];
        }

        return payload;
    }

    function MatchNetLookupExcelExportPayload() {
        const lookupArr = lookupProducts.map((datum) => {
            const children = datum.children.map(child => child.id).join(",");
            const obj = {
                product_a: datum.parent.id,
                product_b: children,
            }
            
            return obj;
        })

        const payload = {
            algorithm: selectedAlgorithm,
            products: lookupArr,
        };
        
        return payload;
    }

    function MatchNetCrossStudyComparisonExcelExportPayload() {
        // const lookupArr = lookupProducts.map((datum) => {
        //     const children = datum.children.map(child => child.id).join(",");
        //     const obj = {
        //         product_a: datum.parent.id,
        //         product_b: children,
        //     }
            
        //     return obj;
        // })
        // console.log("selectedProducts",lookupSelectedProducts,productCategoryData,matchNetConsumerFilters,matchNetWeightToggle,allDataMappingFilters);
        const coreDataIds = lookupSelectedProducts.map((ele) => ele.core_data_model)?.join(",");
        const studyTypeIds = [
            ...new Set(
                lookupSelectedProducts
                    .map((group) => group.study_type_id)
                    .filter((v) => v !== undefined && v !== null && v !== "")
            ),
        ].join(",");

        const studyTypeMethodIds = [
            ...new Set(
                lookupSelectedProducts
                    .map((group) => group.study_type_method_id)
                    .filter((v) => v !== undefined && v !== null && v !== "")
            ),
        ].join(",");


        let methodData = [];
        allDataMappingFilters.forEach((datum) => {
            const isWeightCapable = matchNetProductSecondaryData.find(
                (item) => item.studyTypeMethodTitle === datum.study_type_method_title
            )?.weighted;

            const rawWeightToggle =
                matchNetWeightToggle.find((item) => item.studyTypeMethodTitle === datum.study_type_method_title)?.weightToggle || false;
            const weightToggle = isWeightCapable && !matchNetCorrelationToggle ? rawWeightToggle : false;


            const productsData = lookupSelectedProducts.map((product) => {
                const productTitle = product?.title
                    .split(" ")
                    .filter((ele) => ele !== "")
                    .join("_");
                const productTitleWithId = productTitle + "__" + product?.core_data_model;
                const consumerFilter = matchNetConsumerFilters[datum.study_type_method_title]["currentSelectedFilters"] || {};
                // console.log("consumerFilter",consumerFilter,product?.title,product?.core_data_model);
                const filter = consumerFilterPayload(consumerFilter, productTitle, product?.core_data_model);
                // console.log("filter",filter);
                const productObj = {
                    core_data_model_id: product?.core_data_model,
                    product_code: product?.title,
                    applied_consumer_filters: filter,// matchNetConsumerFilters[datum.study_type_method_title][][productTitle]?.filters,
                    missing_consumer_filters: formatMissingFilters(matchNetConsumerFilters[datum.study_type_method_title]?.missingFilters[productTitleWithId]?.filters)
                }
                return productObj;
            })
            const obj = { 
                study_type_method: datum.study_type_method,
                backend_variables: matchNetCheckedVariablesList[datum.study_type_method_title],
                weight_toggle: weightToggle,
                filter_across_products_toggle: matchNetConsumerFilters[datum.study_type_method_title]?.isFilterAcrossProducts,
                products: productsData
            };
            methodData.push(obj);
        });

        const finalProducts = lookupSelectedProducts.filter((datum) => {
            const formattedKey = `checked--${datum?.title.split(" ").filter((ele) => ele !== "").join("_")}__${datum.core_data_model}`;
            return productsVisibility[formattedKey] === true;
        });
        const hiddenProducts = finalProducts.map((datum) => ({ product_code: datum?.title, core_data_model_id: datum?.core_data_model }));

        const payload = {
            module_name: selectedAlgorithm === "home_use_test" ? "MatchNet - Cross Study Comparison (Home Use Test Compatibility Context)" : "MatchNet - Cross Study Comparison (Fragrance Test Compatibility Context)",
            core_data_model_id: coreDataIds,
            product_category: productCategoryData?.value,
            study_type: studyTypeIds,
            study_type_methods: studyTypeMethodIds,
            method_data: methodData,
            hidden_product: hiddenProducts,
        };

        if (matchNetCorrelationToggle) {
            payload["correlation_toggle"] = matchNetCorrelationToggle;
            payload["correlation_method"] = matchNetCorrelationMethod;
            payload["correlation_target_variable"] = matchNetCorrelationTargetVariable;
            payload["correlation_study_type_method"] = matchNetCorrelationStudyTypeMethod;
        }

        if (interpolationToggle) {
            const { id } = interpolationDetails?.studyTypeMethod || {};
            payload["interpolation_toggle"] = interpolationToggle;
            payload["target_scale"] = Number(interpolationDetails?.likertScale);
            payload["target_country"] = interpolationDetails?.country;
            payload["target_study_type_method"] = id;
        }
        
        return payload;
    }

    const handleExcelExport = () => {
        try {
            if (page !== "driverAnalysis" && page !== "respondentSettings") {
                if (downloadComponentName && downloadPageName) {
                    setIsDownloading(true);
                    const urlPath = urls[page];
                    let _payload = {};
                    if (page === "respondentProfile") {
                        _payload = RespondentExcelExportPayload();
                    } else if (page === "matchNetLookup") {
                        _payload = MatchNetLookupExcelExportPayload();
                    } else if (page === "matchNetCrossStudyComparison") {
                        _payload = MatchNetCrossStudyComparisonExcelExportPayload();
                    } else {
                        _payload = AnalysisResultExcelExportPayload(downloadComponentName, downloadPageName);
                    }
                    api.post(urlPath, { ..._payload }, { responseType: "arraybuffer" })
                        .then((res) => {
                            const blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

                            const disposition = res.headers["content-disposition"] || res.headers["Content-Disposition"]; // to get file name

                            let filename = page + "-report.xlsx"; // Default filename

                            if (disposition && disposition.indexOf("attachment") !== -1) {
                                const matches = /filename[^;=\n]*=((['"]).*?(\2|)|[^;\n]*)/.exec(disposition);
                                if (matches != null && matches[1]) {
                                    filename = matches[1].replace(/['"]/g, ""); // Remove quotes from the filename
                                }
                            }
                            // Create an anchor element and trigger a click event to initiate the download
                            const link = document.createElement("a");
                            link.href = window.URL.createObjectURL(blob);
                            link.download = filename;
                            link.click();

                            // Clean up by revoking the Blob URL to free up memory
                            //URL.revokeObjectURL(blobUrl);
                            setIsDownloading(false);
                            handleDownloadDialogClose();
                        })
                        .catch((error) => {
                            handleError("error", error);
                        });
                } else {
                    try {
                        const urlPath = urls[page];
                        if (!(urlPath.includes("start_date") && urlPath.includes("end_date"))) {
                            handleError("warning", "Select start and end date!");
                        } else {
                            window.open(urlPath, "_blank");
                            handleDownloadDialogClose();
                        }
                    } catch (error) {
                        handleError("error", error);
                    }
                }
            } else if (page === "respondentSettings") {
                let url = urls[page];
                window.open(url);
                handleDownloadDialogClose();
            } else {
                const id = window?.location?.href?.split("id=")?.pop() || null;
                if (window.location.href.split("/").indexOf("driver-analysis") !== -1 && id) {
                    let url = process.env.REACT_APP_SERVER_PATH + `/driver-analysis-output/export/?id=${id}&user=${userId}`;
                    const view = locationState.state?.view;
                    if (view && view === "shared") {
                        url += `&shared=true`;
                    }
                    window.open(url);
                    handleDownloadDialogClose();
                } else {
                    handleError("error", "Report ID is missing.");
                }
            }
        } catch (error) {
            handleError("error", error);
        }
    };

    const handleClaimsMappingExcelExport = (component) => {
        let urlPath = process.env.REACT_APP_SERVER_PATH;
        if (component === "Mapping") {
            urlPath += `/claims-mappings/export-excel/`;
            if (productCategoryId) {
                urlPath += `?product_category=${productCategoryId}`;
            }
            if (selectedClaimsTags.length) {
                const ids = claimsTags.filter((datum) => selectedClaimsTags.indexOf(datum.title) !== -1).map((ele) => ele.id);
                if (productCategoryId) {
                    urlPath += `&tags=${ids.join(",")}`;
                } else {
                    urlPath += `?tags=${ids.join(",")}`;
                }
            }
            window.open(urlPath);
            handleDownloadDialogClose();
        } else if (component === "uam") {
            if (startDate && endDate) {
                urlPath += startDate && endDate ? `/claims-mappings/export-user-access-excel/?start_date=${startDate}&end_date=${endDate}&` : `/claims-mappings/export-user-access-excel/?`;
                if (productCategoryId) {
                    urlPath += `product_category=${productCategoryId}`;
                }

                window.open(urlPath);
                handleDownloadDialogClose();
            } else {
                handleError("warning", "Select start and end date!");
            }
        }
    };

    const handleUserManagementExport = (type) => {
        let url = urls.userManagement[type];

        if (type === "access") {
            if (!userAccessDates.start || !userAccessDates.end) {
                handleError("warning", "Select start and end date for User Access Management!");
                return;
            }
            url += `?product_category=${productCategoryId}&start_date=${userAccessDates.start}&end_date=${userAccessDates.end}`;
        } else if (type === "usage") {
            if (!usageTrackingDates.start || !usageTrackingDates.end) {
                handleError("warning", "Select start and end date for Usage Tracking!");
                return;
            }
            url += `?product_category=${productCategoryId}&start_date=${usageTrackingDates.start}&end_date=${usageTrackingDates.end}`;
        }

        window.open(url);
        handleDownloadDialogClose();
    };

    const handlecentralizedDataMappingExport = () => {
        let urlPath = urls[page];

        if (startDate && endDate) {
            urlPath += `&start_date=${startDate}&end_date=${endDate}`;
            window.open(urlPath);
            handleDownloadDialogClose();
        } else {
            handleError("warning", "Select start and end date!");
        }
    };

    const content = () => {
        return (
            <>
                Data will be exported soon ...
                {/* <br />
                Please click on download button once it's active. */}
            </>
        );
    };

    const actions = () => {
        return (
            <>
                <Button
                    onClick={handleDownloadDialogClose}
                    variant="outlined"
                    color="primary"
                    className="custom-btn custom-btn-outlined color-blue"
                >
                    Back
                </Button>
                {!isDownloading ? (
                    <Button
                        onClick={handleExcelExport} // Call the function for general export
                        variant="contained"
                        color="primary"
                        disabled={isDownloading}
                        className="custom-btn liner-light-blue-background"
                        style={{
                            backgroundColor: "#005eef",
                        }}
                    >
                        Export to Excel
                    </Button>
                ) : (
                    <span style={{ margin: "5px 20px" }}>
                        <CircularProgress
                            sx={{ color: "#3f50b5", margin: "5px 20px" }}
                            size={20}
                        />
                    </span>
                )}
            </>
        );
    };

    const dialogueUIContent = {
        title: {
            overallKpi: "Export Overall Analysis Data",
            secondaryAttribute: "Export Secondary Attribute Analysis Data",
            correlation: "Export correlation Analysis Data",
            respondentProfile: "Export Respondent Data",
            agreementComparison: "Export Agreement Analysis Data",
            userManagement: "Excel Export",
            driverAnalysis: "Export Driver Analysis Report",
            claimsMapping: "Excel Export",
            claimsAnalysis: "Export Claims Analysis Data",
            respondentSettings: "Please Select the Time Frame Below",
            justRightAnalysis: penaltyToggle ? "Export Penalty Analysis Data" : isJar ? "Export Jar Analysis Data" : "Export Just Right Analysis Data",
            centralizedDataMapping: "Excel Export",
            preferenceAnalysis: "Export Preference Analysis Data",
            productPreferenceAnalysis: "Export Product Preference Analysis Data",
            fragranceMetricsAnalysis: "Export Fragrance Metrics Analysis Data",
            fragranceAssociationAnalysis: "Export Fragrance Association Data",
            textThemeAnalysis: "Export Theme Text Analysis Data",
            matchNetLookup: "Export MatchNet Lookup Data",
            matchNetCrossStudyComparison: "Export MatchNet Cross Study Comparison Data",
        },
        content: {
            overallKpi: content(),
            secondaryAttribute: content(),
            correlation: content(),
            respondentProfile: content(),
            agreementComparison: content(),
            driverAnalysis: content(),
            claimsAnalysis: content(),
            respondentSettings: (
                <>
                    <p style={{ fontSize: 12 }}>Specify Time Frame:</p>
                    <div style={{ textAlign: "center" }}>
                        <RangePicker
                            format="DD-MM-YYYY"
                            className="w-100 month-year--picker"
                            onChange={handleStartDateChange}
                            placeholder={["Start Date", "End Date"]}
                        />
                    </div>
                </>
            ),
            userManagement: (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-around",
                        position: "relative",
                        opacity: isDownloading ? "0.3" : "1",
                        gap: "30px",
                    }}
                >
                    {/* Usage Tracking Section - First (Left Side) */}
                    <div
                        style={{
                            textAlign: "center",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            width: "45%",
                        }}
                    >
                        <div style={{ textAlign: "center" }}>
                            <ListItemIcon>
                                <div>
                                    <img
                                        alt="usageTracking"
                                        src={claimsMapping}
                                        style={{
                                            color: "#005eef",
                                            padding: "6px",
                                            width: "50px",
                                        }}
                                    />
                                </div>
                            </ListItemIcon>
                            <p
                                style={{
                                    fontSize: 14,
                                    fontWeight: "bold",
                                    marginBottom: "15px",
                                }}
                            >
                                Driver Analysis Usage Tracker
                            </p>
                        </div>
                        <div>
                            <p
                                style={{
                                    fontSize: 12,
                                    marginBottom: "6px",
                                    textAlign: "left",
                                }}
                            >
                                Specify Time Frame:
                            </p>
                            <div
                                style={{
                                    textAlign: "center",
                                    marginBottom: "15px",
                                }}
                            >
                                <RangePicker
                                    format="DD-MM-YYYY"
                                    className="w-100 month-year--picker"
                                    onChange={handleUsageTrackingDateChange}
                                    placeholder={["Start Date", "End Date"]}
                                />
                            </div>
                        </div>
                        <div
                            style={{
                                textAlign: "center",
                                marginTop: "10px",
                            }}
                        >
                            {!isDownloading ? (
                                <Button
                                    onClick={() => handleUserManagementExport("usage")}
                                    variant="contained"
                                    color="primary"
                                    disabled={isDownloading}
                                    className="custom-btn liner-light-blue-background"
                                    style={{
                                        backgroundColor: "#005eef",
                                    }}
                                >
                                    Export to Excel
                                </Button>
                            ) : (
                                <span style={{ margin: "5px 20px" }}>
                                    <CircularProgress
                                        sx={{ color: "#3f50b5", margin: "5px 20px" }}
                                        size={20}
                                    />
                                </span>
                            )}
                        </div>
                    </div>

                    {/* User Access Management Section - Second (Right Side) */}
                    <div
                        style={{
                            textAlign: "center",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                            width: "45%",
                        }}
                    >
                        <div>
                            <ListItemIcon>
                                <img
                                    src={excelIcon}
                                    alt="Excel Export"
                                    style={{
                                        width: "50px",
                                        height: "50px",
                                    }}
                                />
                            </ListItemIcon>
                            <p
                                style={{
                                    fontSize: 14,
                                    fontWeight: "bold",
                                    marginBottom: "15px",
                                }}
                            >
                                User Access Management
                            </p>
                        </div>
                        <div>
                            <p
                                style={{
                                    fontSize: 12,
                                    marginBottom: "6px",
                                    textAlign: "left",
                                }}
                            >
                                Specify Time Frame:
                            </p>
                            <div
                                style={{
                                    textAlign: "center",
                                    marginBottom: "15px",
                                }}
                            >
                                <RangePicker
                                    format="DD-MM-YYYY"
                                    className="w-100 month-year--picker"
                                    onChange={handleUserAccessDateChange}
                                    placeholder={["Start Date", "End Date"]}
                                />
                            </div>
                        </div>
                        <div
                            style={{
                                textAlign: "center",
                                marginTop: "10px",
                            }}
                        >
                            {!isDownloading ? (
                                <Button
                                    onClick={() => handleUserManagementExport("access")}
                                    variant="contained"
                                    color="primary"
                                    disabled={isDownloading}
                                    className="custom-btn liner-light-blue-background"
                                    style={{
                                        backgroundColor: "#005eef",
                                    }}
                                >
                                    Export to Excel
                                </Button>
                            ) : (
                                <span style={{ margin: "5px 20px" }}>
                                    <CircularProgress
                                        sx={{ color: "#3f50b5", margin: "5px 20px" }}
                                        size={20}
                                    />
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            ),
            claimsMapping: (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-around",
                        position: "relative",
                        opacity: isDownloading ? "0.3" : "1",
                    }}
                >
                    <div
                        style={{
                            textAlign: "center",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                        }}
                    >
                        <div>
                            <ListItemIcon>
                                <img
                                    src={excelIcon}
                                    alt="Excel Export"
                                    style={{
                                        width: "50px",
                                        height: "50px",
                                    }}
                                />
                            </ListItemIcon>
                            <p
                                style={{
                                    fontSize: 14,
                                    fontWeight: "bold",
                                }}
                            >
                                Claims Mapping
                            </p>
                        </div>
                        {!isDownloading ? (
                            <Button
                                onClick={() => handleClaimsMappingExcelExport("Mapping")}
                                variant="contained"
                                color="primary"
                                disabled={isDownloading}
                                className="custom-btn liner-light-blue-background"
                                style={{
                                    backgroundColor: "#005eef",
                                }}
                            >
                                Export to Excel
                            </Button>
                        ) : (
                            <span style={{ margin: "5px 20px" }}>
                                <CircularProgress
                                    sx={{ color: "#3f50b5", margin: "5px 20px" }}
                                    size={20}
                                />
                            </span>
                        )}
                    </div>
                    <div
                        style={{
                            textAlign: "center",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                        }}
                    >
                        <div
                            style={{
                                textAlign: "center",
                            }}
                        >
                            <ListItemIcon>
                                <div>
                                    <img
                                        alt="claimsMapping"
                                        src={claimsMapping}
                                        style={{
                                            color: "#005eef",
                                            padding: "6px",
                                            width: "50px",
                                        }}
                                    />
                                </div>
                            </ListItemIcon>
                            <p
                                style={{
                                    fontSize: 14,
                                    fontWeight: "bold",
                                }}
                            >
                                Claims User Access Management
                            </p>
                        </div>
                        <div>
                            <p
                                style={{
                                    fontSize: 12,
                                    marginBottom: "6px",
                                    textAlign: "left",
                                }}
                            >
                                Specify Time Frame:
                            </p>
                            <div style={{ textAlign: "center" }}>
                                <RangePicker
                                    format="DD-MM-YYYY"
                                    className="w-100 month-year--picker"
                                    onChange={handleStartDateChange}
                                    placeholder={["Start Date", "End Date"]}
                                />
                            </div>
                        </div>
                        <div style={{ textAlign: "center" }}>
                            {!isDownloading ? (
                                <Button
                                    onClick={() => handleClaimsMappingExcelExport("uam")}
                                    variant="contained"
                                    color="primary"
                                    disabled={isDownloading}
                                    className="custom-btn liner-light-blue-background"
                                    style={{
                                        backgroundColor: "#005eef",
                                        marginTop: "14px",
                                    }}
                                >
                                    Export to Excel
                                </Button>
                            ) : (
                                <span style={{ margin: "5px 20px" }}>
                                    <CircularProgress
                                        sx={{ color: "#3f50b5", margin: "5px 20px" }}
                                        size={20}
                                    />
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            ),
            justRightAnalysis: content(),
            centralizedDataMapping: (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-around",
                        position: "relative",
                        opacity: isDownloading ? "0.3" : "1",
                    }}
                >
                    <div
                        style={{
                            textAlign: "center",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "space-between",
                        }}
                    >
                        <div
                            style={{
                                textAlign: "center",
                            }}
                        >
                            <ListItemIcon>
                                <img
                                    src={excelIcon}
                                    alt="Excel Export"
                                    style={{
                                        width: "50px",
                                        height: "50px",
                                    }}
                                />
                            </ListItemIcon>
                            <p
                                style={{
                                    fontSize: 14,
                                    fontWeight: "bold",
                                }}
                            >
                                Centralized User Access Management
                            </p>
                        </div>
                        <div>
                            <p
                                style={{
                                    fontSize: 12,
                                    marginBottom: "6px",
                                    textAlign: "left",
                                }}
                            >
                                Specify Time Frame:
                            </p>
                            <div style={{ textAlign: "center" }}>
                                <RangePicker
                                    format="DD-MM-YYYY"
                                    className="w-100 month-year--picker"
                                    onChange={handleStartDateChange}
                                    placeholder={["Start Date", "End Date"]}
                                />
                            </div>
                        </div>
                        <div style={{ textAlign: "center" }}>
                            {!isDownloading ? (
                                <Button
                                    onClick={() => handlecentralizedDataMappingExport()}
                                    variant="contained"
                                    color="primary"
                                    disabled={isDownloading}
                                    className="custom-btn liner-light-blue-background"
                                    style={{
                                        backgroundColor: "#005eef",
                                        marginTop: "14px",
                                    }}
                                >
                                    Export to Excel
                                </Button>
                            ) : (
                                <span style={{ margin: "5px 20px" }}>
                                    <CircularProgress
                                        sx={{ color: "#3f50b5", margin: "5px 20px" }}
                                        size={20}
                                    />
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            ),
            preferenceAnalysis: content(),
            productPreferenceAnalysis: <div style={{ textAlign: "center" }}>Excel Export functionality under development</div>,
            fragranceMetricsAnalysis: content(),
            fragranceAssociationAnalysis: <div style={{ textAlign: "center" }}>Excel Export functionality under development</div>,
            textThemeAnalysis: content(),
            matchNetLookup: content(),
            matchNetCrossStudyComparison: content(),
        },
        action: {
            overallKpi: actions(),
            secondaryAttribute: actions(),
            correlation: actions(),
            respondentProfile: actions(),
            agreementComparison: actions(),
            driverAnalysis: actions(),
            claimsAnalysis: actions(),
            respondentSettings: actions(),
            justRightAnalysis: actions(),
            preferenceAnalysis: actions(),
            productPreferenceAnalysis: (
                <Button onClick={handleDownloadDialogClose}
                variant="outlined"
                color="primary"
                className="custom-btn custom-btn-outlined color-blue">
                    Back
                </Button>
            ),
            fragranceMetricsAnalysis: actions(),
            fragranceAssociationAnalysis: (
                <Button onClick={handleDownloadDialogClose}
                variant="outlined"
                color="primary"
                className="custom-btn custom-btn-outlined color-blue">
                    Back
                </Button>
            ),
            textThemeAnalysis: actions(),
            matchNetLookup: actions(),
            matchNetCrossStudyComparison: actions(),
        },
    };

    const returnComponentData = (name) => {
        if (page && dialogueUIContent[name][page]) {
            let componentData = dialogueUIContent[name][page];
            return componentData;
        } else if (page === "claimsMapping" || page === "centralizedDataMapping" || page === "userManagement") {
            return "";
        } else if (page === "respondentSettings") {
            return dialogueUIContent.content.respondentSettings;
        } else {
            return "Module Under Development";
        }
    };

    const handleError = (type, error) => {
        dispatch(showNotification({ severity: type, data: error }));
    };

    return (
        open && (
            <Dialog
                open={open}
                maxWidth={"sm"}
                fullWidth
            >
                <DialogTitle
                    style={{
                        backgroundColor: "rgb(51, 94, 234,0.1)",
                        color: "rgb(51, 94, 234)",
                        fontSize: 16,
                        textAlign: "center",
                        padding: "10px 12px",
                    }}
                // className="liner-light-blue-background-2"
                >
                    {returnComponentData("title")}
                    <ClearIcon
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 10,
                            color: "rgb(51, 94, 234) !important",
                            cursor: "pointer",
                        }}
                        size="small"
                        onClick={handleDownloadDialogClose}
                    />
                </DialogTitle>
                <DialogContent
                    style={{
                        padding: "20px 40px",
                    }}
                >
                    {returnComponentData("content")}
                </DialogContent>
                <DialogActions>{returnComponentData("action")}</DialogActions>
            </Dialog>
        )
    );
}

// Typechecking props for the Header
DownloadDialog.propTypes = {
    open: PropTypes.bool,
    setOpen: PropTypes.func,
    // tTestPerformed: PropTypes.bool,
    // tTestconfidenceInterval: PropTypes.string,
    // tTestType: PropTypes.string,
    // tTestProducts: PropTypes.string,
    // tTestCoreDataId: PropTypes.number,
    // tTestCheckedDataTypeForTest: PropTypes.string,
    // tTestAnalysisType: PropTypes.string,
};

export default DownloadDialog;
